import type { HeroAction, HeroMetric } from "./homeConfig";

export const heroUsesMetric = (actions: HeroAction[], metric: HeroMetric): boolean =>
  actions.some((a) => a.metric === metric);
